module.exports = __webpack_public_path__ + "img/csr_swiper_04_mobile.9459fa3b.jpg";